import { render, staticRenderFns } from "./AnharAlkhair.vue?vue&type=template&id=6a5ae0e8&"
import script from "./AnharAlkhair.vue?vue&type=script&lang=js&"
export * from "./AnharAlkhair.vue?vue&type=script&lang=js&"
import style0 from "./AnharAlkhair.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports